import { IExportColumnModel } from "../../../../../shared/models";

export const FieldsColumnList: IExportColumnModel[] = [
]